<template>
  <div class="h-full rounded-lg flex flex-col gap-2 relative ">
    <!-- Confirmation Dialog -->
    <SimpleConfirmComponent
      v-if="showConfirmDialog"
      :message="confirmDialogMessage"
      @confirm="handleConfirm"
      @cancel="handleCancel"
    />

    <div
      class="flex flex-col gap-2 overflow-y-auto scrollbar-thin scrollbar-orange"
    >
      <div class="flex flex-row gap-2 w-full">
        <AppUserForm
          :show="show_user_form"
          disable_visibility="true"
          update_visibility="true"
          :form_title="user_form_title"
          :form_data="user_formData"
          :create_user="create_user_"
          :set_data="user_setData"
          @close="closeForm"
          @show_table="show_form_table"
          @createUser="create_user"
          @updateUser="update_user"
          @disableUser="disable_user_alter"
          @setTipoUtilizador="setTipoUtilizador"
        />

        <div id="table_container" class="h-full flex flex-col gap-2 w-full">
          <div class="w-full">
            <AppPerfilForm
              v-if="show_perfil_form"
              :formData="form_perfil_data"
              :show="show_perfil_form"
              @close="close_perfil"
              @showPerfis="handleShowPerfis"
              :form_title="form_perfil_title"
              :isPerfilView="false"
              @update="handleFormUpdate"
              @perfilCopyChanged="set_perfil"
            />
            <GenericDataTable
              v-if="show_generic_set_table"
              :show="show_generic_set_table"
              :visibility="true"
              :useServerSide="false"
              :tableData="generic_set_table_data"
              :columns="valenciasUtilizadorColumns"
              :table_title="generic_set_table_title"
              :show_close_btn="true"
              :show_export="false"
              scroll-y="40vh"
              @action="handleValenciaUtilizadorAction"
              @close="close_generic_table"
            />
          </div>
          <div class="w-full">
            <AppCalendar
              :show="show_calendar"
              :dates="utilizador_ferias"
              title="Calendário de Férias"
              @close="close_calendar"
              @save="save_calendar"
            />

            <AppAssiduidade
              :show="show_faltas"
              :absences="utilizador_faltas"
              title="Faltas"
              @close="close_faltas"
            />

            <AppTransferirOrdemServico
              v-if="show_transferir_ordemServico"
              :show="show_transferir_ordemServico"
              :tecnico-id="user_formData.id"
              title="Transferir Ordem Serviço"
              :mostrarIconesTecnico="false"
              :mostrarIconesArmazem="true"
              @close="close_transferir_ordemServico"
            />

            <AppTranferirArtigoViatura
              v-if="show_transfer_viatura"
              :parent_tecnico="utilizador"
              @close="close_transferir_artigo_viatura"
            />
            <AppDocumento
              v-if="show_documentoUtilizador"
              :utilizadorId="utilizador.id"
              @close="close_documentoUtilizador"
            />
            <AppSchedule
              v-if="show_horario"
              @close="close_horario"
              :horario="utilizador_horario"
              @save="save_horario"
            />
            <GenericDataTable
              v-if="show_generic_table"
              :show="show_generic_table"
              :visibility="true"
              :useServerSide="false"
              :tableData="generic_table_data"
              :columns="currentTableColumns"
              :table_title="generic_table_title"
              :show_close_btn="true"
              :show_export="false"
              scroll-y="40vh"
              @row-click="handleGenericRowClick"
              @action="handleGenericAction"
              @close="close_generic_table"
            />

            <GenericDataTable
              v-if="show_ordemServico"
              ref="dataTableRef"
              @row-click="handleRowClicked"
              :api-url="`${baseURl}/api/v1/ordemservicoP/utilizador_id/${user_formData.id}/pagination/`"
              :useServerSide="true"
              :columns="ordemServicoColumns"
              :preserve-api-order="true"
              :show_export="true"
              :show_close_btn="true"
              @close="close_ordemServico"
              table_title="Ordens de Serviço"
              scroll-y="40vh"
            >
            </GenericDataTable>
          </div>
        </div>
      </div>
      <!-- <div class="w-full">
        <AppTablePagination
          :show_export="validPermission('U0002')"
          :filterBtn="true"
          :data="filter_data"
          :visibility="this.validPermission('U0006')"
          :show="show_table"
          table_title="Utilizador"
          @row-clicked="select_user"
          @delete_data="disable_user"
          :AddRemoveBtn="{ verAdicionar: this.validPermission('U0003') }"
          @open-adicionar="triggerAction({ action: 'create_utilizador' })"
          @open-historico="triggerAction({ action: 'ver_historico' })"
          :page_display="show_user_form ? 5 : 15"
          :hidden-columns="[
            'id',
            'contato',
            'telefone',
            'telemovel',
            'objetivo',
            'rae',
            'tpa',
            'horario',
            'cert rae',
          ]"
          class="h-full"
          :urlString="urlString"
          :refresh="refresh"
          @open-filter="showFilter = true"
          @refreshed="refresh = false"
        />
      </div> -->
      <div class="w-full" v-if="validPermission('U0006')">
        <!-- Um separador por tipo de utilizador. Só a tabela do separador ativo
             é montada, para não fazer três pedidos paginados de cada vez. -->
        <div class="flex gap-2 mb-2">
          <button
            v-for="tab in utilizadorTabs"
            :key="tab.key"
            :class="[
              'tab-btn',
              activeUserTab === tab.key ? 'tab-btn-active' : 'tab-btn-inactive',
            ]"
            @click="activeUserTab = tab.key"
          >
            {{ tab.label }}
          </button>
        </div>

        <GenericDataTable
          :key="activeUserTab"
          ref="utilizadoresTableRef"
          @row-click="select_user"
          :api-url="`${baseURl}/api/v1/utilizador/tablefilter/pagination/`"
          :initial-params="{ tpUtilizador_id: activeTab.tpId }"
          :useServerSide="true"
          :columns="activeTab.columns"
          :preserve-api-order="true"
          :show_export="validPermission('U0002')"
          :show_close_btn="false"
          :selectable="false"
          selection-mode="single"
          :table_title="`Utilizadores · ${activeTab.label}`"
          scroll-y=""
          >
          <template #left-actions>
            <button
              v-if="validPermission('U0003')"
              class="action-btn filter-btn"
              @click="triggerAction({ action: 'create_utilizador' })"
              title="Adicionar"
            >
              <i class="fa-solid fa-circle-plus fa-xl"></i>
            </button>
          </template>
        </GenericDataTable>
      </div>
    </div>
  </div>

  <UtilizadorFilter
    v-if="showFilter"
    :data="filter_data"
    @save="set_filter"
    @close="showFilter = false"
  />
</template>
//#endregion

<script>
import axios from "axios";
import AppTable from "@/components/tables/table.vue";
import AppProfileSearch from "@/components/profileSearch.vue";
import AppSearch from "@/components/search.vue";
import AppNotification from "@/components/notification.vue";
import AppButton from "@/components/updated/button.vue";

import AppForm from "@/components/form.vue";
import AppUserForm from "@/components/forms/utilizador/userForm.vue";
import AppFilter from "@/components/filter/filter.vue";
import AppCalendar from "@/components/calendario/calendario.vue";
import AppPerfilForm from "@/components/perfil/perfilForm.vue";
import AppPerfilTable from "@/components/tables/table.vue";
import AppAssiduidade from "@/components/calendario/assiduidade.vue";
import AppDocumentoUtilizador from "@/components/DocumentoUtilizador.vue";
import AppOrdemServico from "@/components/DocumentoUtilizador.vue";
import AppTransferirOrdemServico from "@/components/forms/artigo/ArtigoTransferOrdem.vue";
import AppTranferirArtigoViatura from "@/components/forms/artigo/artigoTransferViatura.vue";
import AppSchedule from "@/components/calendario/schedule.vue";
import "@fortawesome/fontawesome-free/css/all.css";
import { toast } from "vue3-toastify";
import permissionMixin from "@/permissionMixin.js";
import AppFilterForm from "@/components/filter/filterForm.vue";
import PopupPainel from "@/components/_popupPainel.vue";
import AppTablePagination from "@/components/tablePagination/tablePagination.vue";
import { mapGetters } from "vuex";
import UtilizadorFilter from "@/components/popUps/utilizadorFilter.vue";
import AppDocumento from "@/components/documentos.vue";
import GenericDataTable from "@/components/dataTable/GenericDataTable2.vue";
import SimpleConfirmComponent from "@/components/simpleConfirmComponent.vue";

import { id as loggedID } from "@/extraData";

export default {
  mixins: [permissionMixin],
  name: "appUtilizadores",
  components: {
    UtilizadorFilter,
    AppTable,
    AppTransferirOrdemServico,
    AppForm,
    AppFilter,
    AppProfileSearch,
    AppSearch,
    AppNotification,
    AppUserForm,
    AppButton,
    AppCalendar,
    AppPerfilForm,
    AppPerfilTable,
    AppAssiduidade,
    AppDocumentoUtilizador,
    AppOrdemServico,
    AppSchedule,
    AppFilterForm,
    AppTablePagination,
    PopupPainel,
    AppTranferirArtigoViatura,
    AppDocumento,
    GenericDataTable,
    SimpleConfirmComponent,
  },
  data() {
    return {
      urlString: "utilizador/tablefilter",
      filter_data: null,
      showFilter: false,
      baseURl: process.env.VUE_APP_URL_BASE,
      // utilizador_ordemServicos: [],
      utilizador: {},
      utilizador_perfils: {},
      valencias: [],
      utilizador_ferias: [],
      table_title: "Utilizadores",

      _originalContacto: null,
      _perfilDirty: false,
      _feriasChanged: false,
      refresh: false,

      utilizador_faltas: [],
      utilizador_documentoUtilizadors: [],

      utilizador_horario: [
        {
          id: 1,
          nome: "jose",
          dia: "monday",
          inicio: "10:30",
          fim: "23:00",
          status: "ativo",
          utilizador_id: 1,
        },
        {
          id: 2,
          nome: "jose",
          dia: "wednesday",
          inicio: "9:30",
          fim: "12:30",
          status: "ativo",
          utilizador_id: 1,
        },
      ],

      utilizador_valencias: [],
      current_utilizador_valencias: [],
      utilizador_valencias_id: 0,

      generic_table_data: [],
      generic_set_table_data: [],

      generic_table_title: "Generic Table",
      generic_set_table_title: "Generic Set Table",

      current_table: "none",

      show_user_form: false,
      show_table: true,
      show_action_card: true,
      show_generic_table: false,
      show_generic_set_table: false,
      show_calendar: false,
      show_faltas: false,
      show_documentoUtilizador: false,
      show_ordemServico: false,
      show_transferir_ordemServico: false,
      show_transfer_viatura: false,
      show_horario: false,

      user_form_title: "No Title",

      create_user_: false,
      update_user_: false,
      user_formData: {},
      user_setData: {},

      // perfil Data
      perfis: [],
      perfil: {},
      perfil_geral: {},
      current_perfil: {},
      permissoes: [],
      form_perfil_data: {},
      form_perfil_title: "",
      show_perfil_table: true,
      show_perfil_form: false,

      // Separador ativo da tabela de utilizadores
      activeUserTab: "tecnico",

      // Ids dos tpUtilizador resolvidos por nome em mounted(). Os valores aqui
      // são só o arranque/fallback: os ids não têm de ser iguais entre schemas
      // (safetycv / safetypt), por isso são confirmados contra /tputilizador/.
      tpUtilizadorIds: {
        backoffice: 5,
        tecnico: 9,
        cliente: 8,
      },

      // Colunas por tipo: cada tipo só mostra o que lhe diz respeito. Os clientes
      // não têm armazém, viatura, chefe nem responsável — essas colunas vinham
      // sempre a 'N/A'.
      utilizadorColumnsTecnico: [
        { label: "Utilizador", key: "utilizador", sortable: true },
        { label: "Nome", key: "contacto" },
        { label: "Email", key: "email" },
        { label: "Armazem", key: "armazem" },
        { label: "Viatura", key: "viatura" },
        { label: "Chefe", key: "chefe" },
        { label: "Responsável", key: "responsavel" },
        { label: "Estado", key: "status", type: "badge" },
      ],
      
      utilizadorColumnsBackoffice: [
        { label: "Utilizador", key: "utilizador", sortable: true },
        { label: "Nome", key: "contacto" },
        { label: "Email", key: "email" },
        { label: "Armazem", key: "armazem" },
        { label: "Chefe", key: "chefe" },
        { label: "Responsável", key: "responsavel" },
        { label: "Estado", key: "status", type: "badge" },
      ],
      utilizadorColumnsCliente: [
        { label: "Utilizador", key: "utilizador", sortable: true },
        { label: "Nome", key: "contacto" },
        { label: "Email", key: "email" },
        { label: "Estado", key: "status", type: "badge" },
      ],


      perfisColumns: [
        { label: "Nome", key: "nome", sortable: true },
        { label: "Descrição", key: "descricao", sortable: true },
      ],

      valenciasColumns: [
        { label: "Nome", key: "nome", sortable: true, maxWidth: 200 },
        {
          label: "Estado",
          key: "status",
          sortable: true,
          type: "badge",
          maxWidth: 90,
        },
        {
          label: "Ações",
          key: "actions",
          type: "actions",
          sortable: false,
          maxWidth: 90,
          actions: [
            {
              type: "add",
              icon: "fas fa-plus",
              class:
                "bg-green-500 hover:bg-green-600 text-white px-2 py-1 rounded text-xs",
              title: "Adicionar Valência",
              showIf: (item) => {
                // Show add button only if valencia is NOT already in utilizador_valencias
                return !this.utilizador_valencias.some((v) => v.id === item.id);
              },
            },
          ],
        },
      ],

      valenciasUtilizadorColumns: [
        { label: "Nome", key: "nome", sortable: true, maxWidth: 200 },
        {
          label: "Estado",
          key: "status",
          sortable: true,
          type: "badge",
          maxWidth: 90,
        },
        {
          label: "Ações",
          key: "actions",
          type: "actions",
          sortable: false,
          maxWidth: 90,
          actions: [
            {
              type: "delete",
              icon: "fas fa-trash",
              class:
                "bg-red-500 hover:bg-red-600 text-white px-2 py-1 rounded text-xs",
              title: "Eliminar Valência",
            },
          ],
        },
      ],
      ordemServicoColumns: [
        { label: "ID", key: "id" },
        { label: "Negocio", key: "negocio", sortable: false },
        { label: "Familia", key: "familia", sortable: false },
        { label: "Inicio", key: "data_inicio", type: "datetime" },
        { label: "Fim", key: "data_fim", type: "datetime" },
        { label: "Moeda", key: "moeda", sortable: false },
        { label: "Estado", key: "status", type: "badge" },
      ],

      popUp: {
        show: false,
        message: "",
      },
      loaded: false,
      lastError: null,

      // Confirmation dialog state
      showConfirmDialog: false,
      confirmDialogMessage: "",
      pendingAction: null,
    };
  },
  created() {
    this.setUserForm(null);
    this.carregarTpUtilizadorIds();
  },

  computed: {
    ...mapGetters(["utilizadorX"]),

    utilizadorTabs() {
      return [
        {
          key: "backoffice",
          label: "Backoffice",
          tpId: this.tpUtilizadorIds.backoffice,
          columns: this.utilizadorColumnsBackoffice,
        },
        {
          key: "tecnico",
          label: "Técnicos",
          tpId: this.tpUtilizadorIds.tecnico,
          columns: this.utilizadorColumnsTecnico,
        },
        {
          key: "cliente",
          label: "Clientes",
          tpId: this.tpUtilizadorIds.cliente,
          columns: this.utilizadorColumnsCliente,
        },
        
      ];
    },

    activeTab() {
      return (
        this.utilizadorTabs.find((t) => t.key === this.activeUserTab) ||
        this.utilizadorTabs[0]
      );
    },

    currentTableColumns() {
      // Return appropriate columns based on current_table value
      if (this.current_table === "perfil") {
        return this.perfisColumns;
      } else if (this.current_table === "valencias") {
        return this.valenciasColumns;
      }
      // Default fallback
      return [
        { label: "ID", key: "id", sortable: true },
        { label: "Nome", key: "nome", sortable: true },
      ];
    },
  },

  methods: {
    set_filter(data) {
      this.urlString = "utilizador/tablefilter";
      this.filter_data = JSON.parse(JSON.stringify(data));
      this.showFilter = false;
      this.refresh = true;
    },

    // Confirma os ids dos tipos contra a base em vez de os assumir: os
    // tpUtilizador não têm de ter o mesmo id em todos os schemas. Se a chamada
    // falhar ficam os valores por omissão definidos em data().
    async carregarTpUtilizadorIds() {
      const tipos = await this.select(`${this.baseURl}/api/v1/tputilizador/`);
      if (!Array.isArray(tipos)) return;

      const idPorNome = (nome) =>
        tipos.find((t) => (t.nome || "").trim().toLowerCase() === nome)?.id;

      const encontrados = {
        tecnico: idPorNome("tecnico"),
        cliente: idPorNome("cliente"),
        backoffice: idPorNome("administrador"),
      };

      Object.entries(encontrados).forEach(([chave, id]) => {
        if (id) this.tpUtilizadorIds[chave] = id;
      });
    },

    // Põe à frente o separador correspondente a um tpUtilizador_id, se houver.
    activarSeparadorDoTipo(tpId) {
      if (!tpId) return;
      const tab = this.utilizadorTabs.find((t) => t.tpId === tpId);
      if (tab) this.activeUserTab = tab.key;
    },

    refreshUtilizadoresTable() {
      // Refresh the main utilizadores DataTable (a do separador ativo)
      if (this.$refs.utilizadoresTableRef) {
        this.$refs.utilizadoresTableRef.refresh();
      }
    },

    async create_user(data) {
      const isEmptyObject = (obj) =>
        Object.keys(obj).length === 0 && obj.constructor === Object;
      const contacto_data = {
        nome: data.contacto_nome ? data.contacto_nome : "",
        email: data.email ? data.email : "",
        telefone: data.telefone ? data.telefone : "",
        telemovel: data.telemovel ? data.telemovel : "",
        descricao:
          data.descricao && !isEmptyObject(data.descricao)
            ? data.descricao
            : "",
        tpContacto_id: 1,
      };
      const contacto = await this.create(
        contacto_data,
        `${this.baseURl}/api/v1/contacto/registrar/`
      );
      if (contacto) {
        data = { ...data, contacto: contacto };
        const create_data = this.setData(data);
        const res = await this.create(
          { ...create_data, password: data.password },
          `${this.baseURl}/api/v1/utilizador/registrar/`
        );
        if (res) {
          data.id = res.id;
          await this.registerValencias(res);
          await this.manage_ferias(res);
          await this.registerHorarios(res);
          await this.upload_img(data);
          await this.upload_signature(data);
          const isBlank = (str) => !str || /^\s*$/.test(str);

          const perfilCretaed = await this.set_perfil_data(
            res.id,
            isBlank(data.contacto_nome) ? "N/A" : data.contacto_nome,
            "create"
          );
          if (!perfilCretaed?.id) {
            toast.error(
              `O utilizador foi criado (id ${res.id}) mas o perfil de permissões falhou. Não volte a criar o utilizador; contacte o suporte.`,
              { position: toast.POSITION.TOP_CENTER, autoClose: false }
            );
            this.refreshUtilizadoresTable();
            return;
          }
          const user_perfil = { perfil_id: perfilCretaed.id };
          const perfilLigado = await this.update(
            `${this.baseURl}/api/v1/utilizador/editar/${res.id}/`,
            user_perfil
          );
          if (!perfilLigado) {
            toast.error(
              `O utilizador foi criado (id ${res.id}) mas não foi possível associar-lhe o perfil ${perfilCretaed.id}. Não volte a criar o utilizador; contacte o suporte.`,
              { position: toast.POSITION.TOP_CENTER, autoClose: false }
            );
            this.refreshUtilizadoresTable();
            return;
          }
          await this.saveUtilizadorSubclientes(res.id, data.selectedSubclienteIds);
          this.closeForm();
          toast.success("Utilizador criado com sucesso", {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 1000,
          });
          // Saltar para o separador do tipo criado, senão o utilizador novo
          // ficava numa tabela que não está à vista.
          this.activarSeparadorDoTipo(data?.tipo_utilizador?.id);
          this.refreshUtilizadoresTable();
          this.show_table = true;
        } else {
          // Handle specific error messages
          const errorMessage = this.getErrorMessage("create_user");
          toast.error(errorMessage, {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 3000,
          });
          this.remove(
            `${this.baseURl}/api/v1/contacto/eliminar/${contacto.id}/`
          );
        }
      } else {
        toast.error("Erro Ao Criar Contato!", {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 1000,
        });
      }
    },

    async select_user(data) {
      const loadingToast = toast.loading("Carregando dados...", {
        position: toast.POSITION.TOP_CENTER,
        autoClose: false,
        icon: {
          type: "spinner",
          color: "#ff9b05", // your custom spinner color
        },
      });

      try {
        // Close/hide components
        this.close_generic_table();
        this.close_calendar();
        this.close_faltas();
        this.close_documentoUtilizador();
        this.close_ordemServico();
        this.close_perfil();
        this.close_horario();
        this.clear_valencias();
        this.clear_ferias();
        this.clear_faltas();
        this.clear_documentoUtilizador();
        this.clear_ordemServico();
        this.clear_horario();
        this.close_transferir_artigo_viatura();

        this.create_user_ = false;
        this.user_form_title = "Informação Do Utilizador";

        // 2) Fetch the main user
        const user = await this.select(
          `${this.baseURl}/api/v1/utilizador/${data.id}/`
        );
        console.log("utilizador:", user);

        if (user) {
          this.utilizador = JSON.parse(JSON.stringify(user));

          // // Ordens de serviço do utilizador
          // this.utilizador_ordemServicos = await this.select(
          //     `${this.baseURl}/api/v1/ordemservico/s/utilizador_id/${data.id}/?exact=true&&loggedId=${loggedID}`
          // );

          // Valências
          let utilizador_valencias = await this.select(
            `${this.baseURl}/api/v1/utilizadorvalencia/s/utilizador_id/${data.id}/?exact=true`
          );
          if (utilizador_valencias.length !== 0) {
            this.current_utilizador_valencias = utilizador_valencias;
            this.utilizador_valencias = utilizador_valencias.map(
              ({ tpValencia }) => tpValencia
            );
          }

          // Faltas
          this.utilizador_faltas = await this.select(
            `${this.baseURl}/api/v1/falta/s/utilizador_id/${data.id}/?exact=true&&loggedId=${loggedID}`
          );

          // Férias
          let utilizador_ferias = await this.select(
            `${this.baseURl}/api/v1/ferias/s/utilizador_id/${data.id}/?exact=true&&loggedId=${loggedID}`
          );
          this.utilizador_ferias = utilizador_ferias.map((value) => ({
            id: value.id,
            start: new Date(value.inicio.replace(/-/g, "/")),
            end: new Date(value.fim.replace(/-/g, "/")),
            descricao: value.descricao,
            aceite: value.aceite,
            utilizador_id: value.utilizador_id,
            status: value.status,
          }));

          // Horário
          this.utilizador_horario = await this.select(
            `${this.baseURl}/api/v1/horario/s/utilizador_id/${data.id}/?exact=true&&loggedId=${loggedID}`
          );
          if (this.utilizador_horario.length > 0) {
            user.horario = this.utilizador_horario;
          }
          console.log("utilizador horario:", this.utilizador_horario);

          // Perfil
          this.perfil_geral = await this.select(
            `${this.baseURl}/api/v1/perfil/s/utilizador_id/${user.id}/?exact=true&&loggedId=${loggedID}`
          );
          this.form_perfil_data = this.perfil_geral;
          this.current_perfil = this.perfil_geral;
          user.perfil = {
            id: this.perfil_geral.id,
            nome: this.perfil_geral.nome,
          };

          // Preenche o form
          this.setUserForm(user);
          if (this.utilizador_horario.length > 0) {
            this.user_setData.horario = "Horario Atribuido";
          }

          // Imagem e Assinatura
          await this.get_imagem(user.id);
          await this.get_assinatura(user.id);
          console.log("user_form_data:", this.user_formData);
          console.log("user_set_data:", this.user_setData);
        }

        this.show_user_form = true;

        // 3) Once all requests are done, update the toast to success
        toast.update(loadingToast, {
          render: "Dados carregados com sucesso!",
          type: "success",
          isLoading: false,
          autoClose: 1000,
        });
      } catch (error) {
        // 4) If something fails, show an error message in the same toast
        console.error("Erro ao carregar dados do utilizador:", error);
        toast.update(loadingToast, {
          render: "Erro ao carregar os dados do utilizador!",
          type: "error",
          isLoading: false,
          autoClose: 2000,
        });
      }
    },

    async update_user(data) {
      const isEmptyObject = (obj) =>
        Object.keys(obj).length === 0 && obj.constructor === Object;

      console.log("user to update:", data);
      let contacto = { id: data.contacto_id };

      const contacto_data = {
        nome: data.contacto_nome ? data.contacto_nome : "",
        email: data.email ? data.email : "",
        telefone: data.telefone ? data.telefone : "",
        telemovel: data.telemovel ? data.telemovel : "",
        descricao:
          data.descricao && !isEmptyObject(data.descricao)
            ? data.descricao
            : "",
        tpContacto_id: 1,
      };
      const contactoChanged = this._originalContacto && (
        (data.contacto_nome || "") !== this._originalContacto.nome ||
        (data.email || "") !== this._originalContacto.email ||
        (data.telefone || "") !== this._originalContacto.telefone ||
        (data.telemovel || "") !== this._originalContacto.telemovel ||
        (data.descricao || "") !== this._originalContacto.descricao
      );

      console.log("contacto to update:", contacto_data);
      if (data.contacto_id != 0) {
        if (contactoChanged) {
          await this.update(
            `${this.baseURl}/api/v1/contacto/editar/${data.contacto_id}/`,
            contacto_data
          );
        }
        contacto = { id: data.contacto_id };
      } else {
        if (
          data.contacto_nome != "" &&
          data.email !== "" &&
          data.telemovel !== "" &&
          data.telefone !== ""
        ) {
          contacto = await this.create(
            contacto_data,
            `${this.baseURl}/api/v1/contacto/registrar/`
          );
        }
      }
      console.log("contato:", contacto);
      data = { ...data, contacto: contacto };

      let update_data = this.setData(data);
      console.log("user to update", update_data);
      if (this._perfilDirty) await this.set_perfil_data(data, data.contacto_nome, "update");
      const res = await this.update(
        `${this.baseURl}/api/v1/utilizador/editar/${data.id}/`,
        update_data
      );

      if (res) {
        this.update_user_ = true;
        this.refresh = !this.refresh;
        await this.registerValencias(data);
        await this.deleteValencias();
        if (this._feriasChanged) await this.manage_ferias(data);
        await this.registerHorarios(res);
        await this.upload_img(data);
        await this.upload_signature(data);
        if (data.subclientesChanged) await this.saveUtilizadorSubclientes(data.id, data.selectedSubclienteIds);

        this.closeForm();
        toast.success("Utilizador Atualizado com sucesso", {
          // position: toast.POSITION.TOP_CENTER,
          autoClose: 1000,
        });

        this.refreshUtilizadoresTable();
        this.show_table = true;
      } else {
        // Handle specific error messages
        const errorMessage = this.getErrorMessage("update_user");
        toast.error(errorMessage, {
          autoClose: 3000,
        });
      }
    },
    async disable_user_alter(data) {
      let res = null;
      let message = "",
        error_message = "";
      if (data.status == "ativo") {
        res = await this.remove(
          `${this.baseURl}/api/v1/utilizador/eliminar/${data.id}/`
        );
        this.user_formData.status = "desativado";
        message = "desativado";
        error_message = "desativar";
      } else {
        res = await this.remove(
          `${this.baseURl}/api/v1/utilizador/eliminar/${data.id}/?ativar=true&&loggedId=${loggedID}`
        );
        this.user_formData.status = "ativo";
        message = "ativado";
        error_message = "ativar";
      }

      if (res) {
        toast.success(`Utilizador ${message} com sucesso`, {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 1000,
        });
        this.refreshUtilizadoresTable();
      } else {
        toast.error(`Erro ao ${error_message} Utilizador`, {
          autoClose: 1000,
        });
      }
    },

    async disable_user(data) {
      console.log("parent status:", data);
      let update_data = {
        status: data.status == "ativo" ? "desativado" : "ativo",
      };
      const res = await this.update(
        `${this.baseURl}/api/v1/utilizador/editar/${data.id}/`,
        update_data
      );
      if (res) {
        console.log("utilizador updated", res);
        const message = data.status == "ativo" ? "desativado" : "ativado";
        this.user_formData.status = update_data.status;
        toast.success(`Utilizador ${message} com sucesso`, {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 1000,
        });
        this.refreshUtilizadoresTable();
      } else {
        const message = data.status == "ativo" ? "desativar" : "ativar";
        toast.error(`Erro ao ${message} Utilizador`, {
          autoClose: 1000,
        });
      }
    },

    closeForm() {
      this.show_user_form = false;
      this.close_generic_table();
      this.close_calendar();
      this.close_perfil();
      this.close_faltas();
      this.close_documentoUtilizador();
      this.close_horario();
    },

    close_table() {
      this.show_table = false;
    },
    close_generic_table() {
      if (this.show_generic_table && !this.show_perfil_form) {
        document.getElementById("right_form").style.display = "flex";
      }
      this.show_generic_table = false;
      this.show_generic_set_table = false;
    },

    close_calendar() {
      if (this.show_calendar) {
        document.getElementById("form_btn_container").style.display = "flex";
      }
      this.show_calendar = false;
    },
    close_faltas() {
      if (this.show_faltas) {
        document.getElementById("form_btn_container").style.display = "flex";
      }
      this.show_faltas = false;
    },
    close_documentoUtilizador() {
      if (this.show_documentoUtilizador) {
        document.getElementById("right_form").style.display = "flex";
      }
      this.show_documentoUtilizador = false;
    },
    close_ordemServico() {
      if (this.show_ordemServico) {
        document.getElementById("right_form").style.display = "flex";
      }
      this.show_ordemServico = false;
    },
    close_transferir_ordemServico() {
      if (this.show_transferir_ordemServico) {
        document.getElementById("right_form").style.display = "flex";
      }
      this.show_transferir_ordemServico = false;
    },
    close_transferir_artigo_viatura() {
      if (this.show_transfer_viatura) {
        document.getElementById("right_form").style.display = "flex";
      }
      this.show_transfer_viatura = false;
    },
    handleRowClicked(data) {
      // Lógica para lidar com o clique em uma ordem de serviço//POR FAMILIA
    },
    close_horario() {
      if (this.show_horario) {
        document.getElementById("right_form").style.display = "flex";
      }
      this.show_horario = false;
    },
    close_perfil() {
      if (this.show_perfil_form) {
        this.form_perfil_data = this.current_perfil;
        console.log("Data in the formmm:", this.form_perfil_data);
        console.log("Data in the current:", this.current_perfil);
        document.getElementById("right_form").style.display = "flex";
      }
      this.show_perfil_form = false;
      this.close_generic_table();
    },
    async triggerAction(action) {
      if (action.action === "create_utilizador") {
        this.create_user_ = true;
        this.user_form_title = "Criar Utilizador";
        this.setUserForm(null);
        this.show_user_form = true;
        this.close_generic_table();
        this.close_calendar();
        this.close_faltas();
        this.close_documentoUtilizador();
        this.close_ordemServico();
        this.close_horario();
        this.clear_valencias();
        this.clear_ferias();
        this.clear_faltas();
        this.clear_documentoUtilizador();
        this.clear_ordemServico();
        this.clear_horario();
        this.close_perfil();

        this.show_form_filter = false;
        this.perfil_geral = JSON.parse(localStorage.getItem("userPerfil"));
        this.resetAutorizacao();
        this.current_perfil = this.perfil_geral;
      }
      if (action.action === "show_table") {
        this.show_table = true;
      }
      if (action.action === "criar_filtro") {
        this.show_form_filter = true;
        this.closeForm();
      }
    },
    async create(data, url) {
      try {
        const res = await axios.post(url, data);
        return res.data.data;
      } catch (error) {
        console.error("Error getting data:", error);
        // Store the error response for better error handling
        this.lastError = error.response?.data || error;
        return null;
      }
    },
    async select(url) {
      try {
        const res = await axios.get(url);
        return res.data.data;
      } catch (error) {
        console.error("Error getting data:", error);
      }
    },
    async select_all(url) {
      try {
        const res = await axios.get(url);
        return res.data.data;
      } catch (error) {
        console.error("Error getting data:", error);
      }
    },
    async update(url, data) {
      console.log("data to update:", data);

      try {
        const res = await axios.put(url, data);
        console.log("Data successfully updated:", res.data);
        return res.data.data;
      } catch (error) {
        console.error("Error posting data:", error);
      }
    },
    async remove(url) {
      try {
        await axios.delete(url);
        return true;
      } catch (error) {
        console.error("Error deleting data:", error);
      }
    },

    setUserForm(data) {
      const isEmptyObject = (obj) =>
        Object.keys(obj).length === 0 && obj.constructor === Object;
      this.user_formData = {
        id: data ? data.id : 0,
        contacto_id:
          data && data.contacto && !isEmptyObject(data?.contacto)
            ? data.contacto.id
            : 0,
        utilizador: data ? data.user : "",
        password: data && data.password ? data.password : "",
        nif: data ? data.nif || "" : "",
        cc: data ? data.cc || "" : "",
        certificado: data ? data.certificadoRae || "" : "",
        foto:
          data && data.foto
            ? data.foto
            : require("@/assets/default-profile-img.jpg"),
        contacto_nome: data ? data.contacto?.nome || "" : "",
        email: data ? data.contacto?.email || "" : "",
        //horario: data && data.horario ? 'Horario Atribuido' : 'Não Atribuido',
        telefone: data ? data.contacto?.telefone || "" : "",
        telemovel: data ? data.contacto?.telemovel || "" : "",
        descricao: data ? data.contacto?.descricao || "" : "",
        objetivoDiario: data && data.objetivoDiario ? data.objetivoDiario : 0.0,
        assinatura: data && data.assinatura ? data.assinatura : "",
        status: data && data.status ? data.status : "",
      };

      this._originalContacto = {
        nome: this.user_formData.contacto_nome,
        email: this.user_formData.email,
        telefone: this.user_formData.telefone,
        telemovel: this.user_formData.telemovel,
        descricao: this.user_formData.descricao,
      };
      this._perfilDirty = false;
      this._feriasChanged = false;

      this.user_setData = {
        tipo_utilizador:
          data && data.tipo && !isEmptyObject(data?.tipo)
            ? data.tipo
            : { id: 0, nome: "N/A" },
        perfil:
          data && data.perfil && !isEmptyObject(data?.perfil)
            ? data.perfil
            : { id: 0, nome: "N/A" },
        responsavel:
          data && data.responsavel && !isEmptyObject(data?.responsavel)
            ? data.responsavel
            : { id: 0, user: "N/A" },
        chefe:
          data && data.chefe && !isEmptyObject(data?.chefe)
            ? data.chefe
            : { id: 0, user: "N/A" },
        rae:
          data && data.rae && !isEmptyObject(data?.rae)
            ? data.rae
            : { id: 0, user: "N/A" },
        armazem:
          data && data.armazem && !isEmptyObject(data?.armazem)
            ? data.armazem
            : { id: 0, nome: "N/A" },
        sucursal:
          data && data.sucursal && !isEmptyObject(data?.sucursal)
            ? data.sucursal
            : { id: 0, sucursal: "N/A" },
        viatura:
          data && data.viatura && !isEmptyObject(data?.viatura)
            ? data.viatura
            : { id: 0, matricula: "N/A" },
        tpa:
          data && data.tpa && !isEmptyObject(data?.tpa)
            ? data.tpa
            : { id: 0, serie: "N/A" },
        computador:
          data && data.computador && !isEmptyObject(data?.computador)
            ? data.computador
            : { id: 0, nome: "N/A" },
        horario: data && data.horario ? data.horario : "N/A",
        cliente:
          data && data.cliente && !isEmptyObject(data?.cliente)
            ? data.cliente
            : { id: 0, cliente: "N/A" },
      };
    },

    setData(data) {
      let prepared_data = {
        user: data.utilizador || "",
        // password: data.password || "",
        nif: data.nif || "",
        cc: data.cc || "",
        certificadoRae: data.certificado || "",
        objetivoDiario: data.objetivoDiario
          ? parseFloat(data.objetivoDiario)
          : 0.0,
        chefe_id: data?.chefe?.id || 0,
        responsavel_id: data?.responsavel?.id || 0,
        rae_id: data?.rae?.id || 0,
        contacto_id: data.contacto?.id || 0,
        perfil_id: data?.perfil?.id || 0,
        tpUtilizador_id: data?.tipo_utilizador?.id || 0,
        armazem_id: data?.armazem?.id || 0,
        sucursal_id: data?.sucursal?.id || 0,
        viatura_id: data?.viatura?.id || 0,
        tpa_id: data?.tpa?.id || 0,
        computador_id: data?.computador?.id || 0,
        cliente_id: data?.cliente?.id || 0,
        //status: data.status || ""
      };

      return prepared_data;
    },

    async show_form_table(data) {
      if (data === "valencias") {
        const valencias = await this.select_all(
          `${this.baseURl}/api/v1/tpvalencia/`
        );
        this.valencias = valencias?.sort((a, b) => a.id - b.id);
        this.current_table = data;
        this.generic_table_data = this.valencias;
        this.generic_table_title = "Valências Disponíveis";
        this.show_generic_table = true;
        this.generic_set_table_title = "Valências do utilizador";
        this.generic_set_table_data = this.utilizador_valencias;
        this.show_generic_set_table = true;
        this.popUp = {
          show: true,
        };
        document.getElementById("right_form").style.display = "none";
      } else if (data === "ferias") {
        this.show_calendar = true;
        document.getElementById("form_btn_container").style.display = "none";
      } else if (data === "assiduidade") {
        this.show_faltas = true;
        document.getElementById("form_btn_container").style.display = "none";
      } else if (data === "documentoUtilizador") {
        this.show_documentoUtilizador = true;
        document.getElementById("right_form").style.display = "none";
      } else if (data === "transferirordemServico") {
        this.show_transferir_ordemServico = true;
        document.getElementById("right_form").style.display = "none";
      } else if (data === "transferirArtigoViatura") {
        this.show_transfer_viatura = true;
        document.getElementById("right_form").style.display = "none";
      } else if (data === "ordemServico") {
        this.show_ordemServico = true;
        document.getElementById("right_form").style.display = "none";
      } else if (data === "perfil") {
        document.getElementById("right_form").style.display = "none";
        this.show_perfil_form = true;
        this.show_perfil_table = false;
        this.form_perfil_title = "Atualizar Perfil";

        this.form_perfil_data = this.perfil_geral;

        this.form_perfil_data = this.current_perfil;

        this.current_table = data;
      } else if (data === "horario") {
        document.getElementById("right_form").style.display = "none";
        this.show_horario = true;
      }
    },
    async setTipoUtilizador(data, permissoes) {
      console.log("Tipo Utilizador:", data);
      this.form_perfil_data = this.perfil_geral;
      // console.log('Nome Tipo', data.nome)

      //J..20_02
      if (!data || !data.nome || data.nome.trim() === "") {
        console.error(
          "Erro: Nome do perfil está vazio. A API não será chamada."
        );
        return;
      }
      // As permissões vêm do perfil modelo associado ao tipo
      // (tpUtilizador.perfil_id), não de uma pesquisa pelo nome: essa
      // pesquisa devolvia perfis de outros utilizadores com o tipo no nome.
      // O seletor (tputilizador/?custom=1) só traz o nome do perfil; o
      // tputilizador/<id>/ traz o perfil como objeto, com o id.
      let perfilModeloId =
        data.perfil_id || (typeof data.perfil === "object" ? data.perfil?.id : null);
      if (!perfilModeloId && data.id) {
        const tipo = await this.select(
          `${this.baseURl}/api/v1/tputilizador/${data.id}/`
        );
        perfilModeloId = tipo?.perfil?.id || tipo?.perfil_id;
      }
      if (!perfilModeloId) {
        toast.warning(
          `O tipo "${data.nome}" não tem perfil associado; as permissões não foram preenchidas.`,
          { position: toast.POSITION.TOP_CENTER, autoClose: 3000 }
        );
        return;
      }

      //J.. garantir que respons sempre tenha permissao como um array:
      const respons =
        (await this.select(
          `${this.baseURl}/api/v1/perfil/${perfilModeloId}/`
        )) || {};
      respons.permissao = respons.permissao || [];

      if (respons && respons.permissao) {
        //J.. add && respons.permissao 20_02
        if (this.form_perfil_data && this.form_perfil_data.permissao) {
          this.form_perfil_data.permissao.forEach((item1) => {
            const item2 = respons.permissao.find(
              (item2) => item2.codigo === item1.codigo
            );
            item1.autorizacao = item2 ? item2.autorizacao : "";
          });
          this.current_perfil = this.form_perfil_data;
        }
      } else {
        //J..20_02
        console.warn(
          "A resposta da API não contém a propriedade 'permissao'.",
          respons
        );
      }
    },
    async select_generic_row(data, permissoes) {
      console.log("row selected:", data);
      console.log("current_table:", this.current_table);
      if (this.current_table === "valencias") {
        this.delete_generic_row({ id: 0, nome: "N/A" });
        const isDuplicate = this.utilizador_valencias.some(
          (item) => item.id === data.id
        );
        !isDuplicate
          ? this.utilizador_valencias.push(data)
          : console.log("Duplicated item");
      } else if (this.current_table === "perfil") {
        const respons = await this.select(
          `${this.baseURl}/api/v1/perfil/${data.id}/`
        );
        this.form_perfil_data.permissao.forEach((item1) => {
          const item2 = respons.permissao.find(
            (item2) => item2.codigo === item1.codigo
          );
          if (item2) {
            item1.autorizacao = item2.autorizacao;
          }
        });
        this.user_setData.perfil = {
          id: this.form_perfil_data.id,
          nome: this.form_perfil_data.nome,
        };
      }
    },

    handleGenericRowClick(data) {
      // Handle row click for perfis (not valencias, as they use action buttons)
      if (this.current_table === "perfil") {
        this.select_generic_row(data);
      }
    },

    handleGenericAction({ type, item }) {
      // Handle actions from the generic table (all valencias)
      if (type === "add" && this.current_table === "valencias") {
        this.showConfirmation("Adicionar esta valência ao utilizador?", {
          type: "add",
          item: item,
        });
      }
    },

    handleValenciaUtilizadorAction({ type, item }) {
      // Handle actions from the user's valencias table
      if (type === "delete") {
        this.showConfirmation(
          "Tem certeza que deseja eliminar esta valência?",
          {
            type: "delete",
            item: item,
          }
        );
      }
    },

    showConfirmation(message, action) {
      this.confirmDialogMessage = message;
      this.pendingAction = action;
      this.showConfirmDialog = true;
    },

    handleConfirm() {
      if (this.pendingAction) {
        if (this.pendingAction.type === "add") {
          this.select_generic_row(this.pendingAction.item);
        } else if (this.pendingAction.type === "delete") {
          this.delete_generic_row(this.pendingAction.item);
        }
      }
      this.handleCancel();
    },

    handleCancel() {
      this.showConfirmDialog = false;
      this.confirmDialogMessage = "";
      this.pendingAction = null;
    },

    delete_generic_row(data) {
      if (this.generic_set_table_title === "Valências do utilizador") {
        this.utilizador_valencias.forEach((item, index) => {
          if (item.id === data.id) {
            this.utilizador_valencias.splice(index, 1);
          }
        });
      }
    },

    clear_valencias() {
      this.utilizador_valencias = [{ id: 0, nome: "N/A" }];
      this.current_utilizador_valencias = [];
    },
    clear_horario() {
      this.utilizador_horario = [];
    },

    async registerValencias(res) {
      for (const valencia of this.utilizador_valencias) {
        const valencia_data = {
          tpValencia_id: valencia.id,
          utilizador_id: res.id,
        };

        if (
          valencia.id != 0 &&
          !this.current_utilizador_valencias.some(
            (item) => item.tpValencia.id === valencia.id
          )
        ) {
          console.log("inside");
          await this.create(
            valencia_data,
            `${this.baseURl}/api/v1/utilizadorvalencia/registrar/`
          );
        }
      }
    },

    async deleteValencias() {
      for (const current_valencia of this.current_utilizador_valencias) {
        const exists = this.utilizador_valencias.some(
          (item) => item.id === current_valencia.tpValencia.id
        );
        if (!exists) {
          const delete_res = await this.remove(
            `${this.baseURl}/api/v1/utilizadorvalencia/eliminar/${current_valencia.id}/`
          );
          console.log("deleted:", delete_res);
        }
      }
    },

    save_calendar(data) {
      this.utilizador_ferias = data;
      this._feriasChanged = true;
      console.log("parent ferias:", this.utilizador_ferias);
      this.close_calendar();
    },

    async manage_ferias(user) {
      console.log("ferias to update:", this.utilizador_ferias);
      this.utilizador_ferias.map(async (ferias) => {
        const ferias_data = {
          inicio: ferias.start.toISOString().split("T")[0],
          fim: ferias.end.toISOString().split("T")[0],
          status: ferias.status,
          utilizador_id: user.id,
          descricao: ferias?.descricao ? ferias.descricao : "",
          aceite: ferias?.aceite ? ferias.aceite : "ok",
        };
        console.log("ferias:", ferias_data);
        if (ferias.id == 0) {
          await this.create(
            ferias_data,
            `${this.baseURl}/api/v1/ferias/registrar/`
          );
        } else {
          if (ferias.status == "deleted")
            await this.remove(
              `${this.baseURl}/api/v1/ferias/eliminar/${ferias.id}/`
            );
          else
            await this.update(
              `${this.baseURl}/api/v1/ferias/editar/${ferias.id}/`,
              ferias_data
            );
        }
      });
    },
    clear_ferias() {
      this.utilizador_ferias = [];
    },
    clear_faltas() {
      this.utilizador_faltas = [];
    },
    clear_documentoUtilizador() {
      this.utilizador_documentoUtilizador = [];
    },
    clear_ordemServico() {
      this.utilizador_ordemServico = [];
    },
    resetAutorizacao() {
      this.perfil_geral.permissao.forEach((permissao) => {
        permissao.autorizacao = "";
      });
    },
    set_perfil(data) {
      this.current_perfil = data;
      this._perfilDirty = true;
    },

    async set_perfil_data(id, nome, action) {
      if (action === "update") {
        console.log("Id of the Perfil to update:", this.current_perfil.id);
        console.log(
          "Data to send to the Perfil and update:",
          this.current_perfil
        );
        let copiedPerfil = {
          data: { ...this.current_perfil },
        };
        const res = await this.update(
          `${this.baseURl}/api/v1/perfil/editar/${this.current_perfil.id}/`,
          copiedPerfil
        );
        if (res) {
          console.log("Response to the perfil updated", res);
        }
      } else if (action === "create") {
        console.log("Entro");
        this.current_perfil.descricao = "user_perfil";
        this.current_perfil.utilizador_id = id;
        this.current_perfil.nome = nome;
        delete this.current_perfil.id;

        let copiedPerfil = {
          data: { ...this.current_perfil },
        };

        console.log("Data to send:", copiedPerfil);
        console.log("Saiu");
        const res = await this.create(
          copiedPerfil,
          `${this.baseURl}/api/v1/perfil/registrar/`
        );
        return res;
      }
    },

    async handleShowPerfis() {
      // Filtragem de utilizador_id = -1 já é feita no backend (evita trazer
      // os ~3240 perfis todos para filtrar no frontend).
      const response = await this.select(
        `${this.baseURl}/api/v1/perfil/utilizador-neg1/`
      );
      this.perfis = (response || []).map((perfil) => {
        delete perfil.utilizador_id;
        return perfil;
      });
      this.generic_table_data = this.perfis;
      this.generic_table_title = "Perfis";
      this.show_generic_table = true;
    },

    save_horario(data) {
      console.log("parent horario:", data);
      if (data.length == 0) {
        this.user_setData.horario = "Não Definido";
      } else this.user_setData.horario = "Horario Definido";

      // Helper function to adjust times that are past midnight
      function adjustTime(time) {
        let [hour, minute] = time.split(":").map(Number);
        if (hour >= 24) {
          hour -= 24;
        }
        return (
          hour.toString().padStart(2, "0") +
          ":" +
          minute.toString().padStart(2, "0")
        );
      }

      // Loop through each item in data
      data.forEach((item) => {
        // Adjust inicio and fim times that are past midnight
        item.inicio = adjustTime(item.inicio);
        item.fim = adjustTime(item.fim);
      });
      console.log("horario to update:", data);

      this.utilizador_horario = data;
      this.close_horario();
    },
    async registerHorarios(res) {
      console.log("horario to update/create:", this.utilizador_horario);
      this.utilizador_horario.map(async (horario) => {
        const horario_data = {
          nome: horario.nome,
          utilizador_id: res.id,
          dia: horario.dia,
          inicio: horario.inicio,
          fim: horario.fim,
          status: "ativo",
        };
        console.log("horario:", horario_data);
        if (horario.status == "novo" && horario.action != "delete") {
          await this.create(
            horario_data,
            `${this.baseURl}/api/v1/horario/registrar/`
          );
        } else if (horario.status == "ativo" && horario.action == "updated") {
          await this.update(
            `${this.baseURl}/api/v1/horario/editar/${horario.id}/`,
            horario_data
          );
        } else if (horario.status == "ativo" && horario.action == "deleted") {
          await this.remove(
            `${this.baseURl}/api/v1/horario/eliminar/${horario.id}/`
          );
        }
      });
    },

    async upload_img(formData) {
      if (formData.newFoto) {
        try {
          const response = await axios.post(
            `${this.baseURl}/api/v1/utilizador/editar/foto/${formData.id}/`,
            formData.newFoto,
            {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            }
          );
          const filePath = response.data.filePath;
          //this.formData.foto = filePath;
          // await this.get_imagem(formData.id);
        } catch (error) {
          console.error("Error uploading file:", error);
        }
      }
    },

    async upload_signature(formData) {
      if (formData.newAssinatura) {
        try {
          const response = await axios.post(
            `${this.baseURl}/api/v1/utilizador/editar/assinatura/${formData.id}/`,
            formData.newAssinatura,
            {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            }
          );
          const filePath = response.data.filePath;
        } catch (error) {
          console.error("Error uploading file:", error);
        }
      }
    },

    async saveUtilizadorSubclientes(utilizadorId, subclienteIds) {
      if (!subclienteIds || !Array.isArray(subclienteIds)) return;
      try {
        await axios.post(
          `${this.baseURl}/api/v1/utilizador/${utilizadorId}/subclientes/save/`,
          { subcliente_ids: subclienteIds }
        );
      } catch (error) {
        console.error("Error saving utilizador subclientes:", error);
      }
    },

    async get_imagem(id) {
      if (id == 0) return;
      try {
        const response = await axios.get(
          `${this.baseURl}/api/v1/utilizador/foto/${id}/`,
          { responseType: "blob" }
        );
        console.log("response:", response.data);
        if (response.status != 200) return;
        this.user_formData.foto = URL.createObjectURL(
          new Blob([response.data])
        );
      } catch (error) {
        console.log(error);
      }
    },

    async get_assinatura(id) {
      if (id == 0) return;
      try {
        const response = await axios.get(
          `${this.baseURl}/api/v1/utilizador/assinatura/${id}/`,
          { responseType: "blob" }
        );
        if (response.status != 200) return;
        this.user_formData.assinatura = URL.createObjectURL(
          new Blob([response.data])
        );
      } catch (error) {
        console.log(error);
      }
    },

    getErrorMessage(context) {
      if (!this.lastError) {
        return "Erro desconhecido.";
      }

      // Handle different error response formats
      let errorMessage = "";

      if (this.lastError.message) {
        // Parse Django validation errors from the message
        const message = this.lastError.message;

        // Check for NIF uniqueness error
        if (message.includes("Utilizador with this nif already exists")) {
          return "Este NIF já está registado no sistema. Por favor, utilize um NIF diferente.";
        }

        // Check for user field uniqueness error
        if (message.includes("Utilizador with this user already exists")) {
          return "Este nome de utilizador já existe. Por favor, escolha um nome diferente.";
        }

        // Check for other validation errors
        if (message.includes("nif") && message.includes("required")) {
          return "O campo NIF é obrigatório.";
        }

        if (message.includes("user") && message.includes("required")) {
          return "O campo nome de utilizador é obrigatório.";
        }

        if (message.includes("password") && message.includes("required")) {
          return "O campo palavra-passe é obrigatório.";
        }

        // Generic validation error
        if (message.includes("Erro ao criar utilizador:")) {
          return "Erro de validação: Verifique se todos os campos estão preenchidos corretamente.";
        }

        errorMessage = message;
      } else if (this.lastError.data && this.lastError.data.message) {
        errorMessage = this.lastError.data.message;
      } else if (typeof this.lastError === "string") {
        errorMessage = this.lastError;
      }

      // Default error messages based on context
      switch (context) {
        case "create_user":
          return (
            errorMessage ||
            "Erro ao criar utilizador. Verifique os dados e tente novamente."
          );
        case "update_user":
          return (
            errorMessage ||
            "Erro ao atualizar utilizador. Verifique os dados e tente novamente."
          );
        default:
          return errorMessage || "Ocorreu um erro. Tente novamente.";
      }
    },
  },
  watch: {
    filter_data: {
      handler: function (newData) {
        console.log("Data to filter:", newData);
      },
      deep: true,
    },
  },
};
</script>
<style>
/* Separadores dos tipos de utilizador — mesmo estilo do stockView */
.tab-btn {
  padding: 0.5rem 1.5rem;
  border-radius: 0.375rem 0.375rem 0 0;
  font-weight: 600;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  border: none;
  cursor: pointer;
  font-size: 0.875rem;
}

.tab-btn-active {
  background-color: var(--button);
  color: var(--text);
  border-bottom: 2px solid var(--button);
}

.tab-btn-inactive {
  background-color: rgba(255, 255, 255, 0.05);
  color: var(--glass-muted);
  border-bottom: 2px solid transparent;
}

.tab-btn-inactive:hover {
  background-color: rgba(255, 255, 255, 0.1);
  color: var(--text);
}

.scroll-style {
  overflow-y: auto;
  scrollbar-color: gray transparent;
  scrollbar-width: thin;
}

.popup {
  position: fixed;
  display: none;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: white;
  padding: 20px;
  border: 1px solid black;
  border-radius: 5px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
}

.popup-content {
  text-align: center;
}

.popup button {
  margin: 0 10px;
  padding: 5px 10px;
  cursor: pointer;
}

.btn {
  font-size: 12px;
  width: fit-content;
  padding: 0.5rem 0.8rem;
  color: white;
  display: flex;
  align-items: center;
  border-radius: 10px;
  background-color: #626288;
}

.btn:hover {
  background-color: #c67700;
}

.Toastify__toast-body {
  background-color: #626288;
}

.Toastify__toast-theme--dark {
  color: white;
  background-color: #626288;
}

.Toastify__toast-theme--light {
  color: white;
  background-color: #626288;
}

.Toastify__toast-theme--colored.Toastify__toast--info {
  color: white;
}

.Toastify__progress-bar--success {
  color: #c67700;
  background-color: #c67700;
}

.Toastify__progress-bar-theme--colored.Toastify__progress-bar--info,
.Toastify__progress-bar-theme--colored.Toastify__progress-bar--success,
.Toastify__progress-bar-theme--colored.Toastify__progress-bar--warning,
.Toastify__progress-bar-theme--colored.Toastify__progress-bar--error {
  color: #c67700;
  background-color: #c67700;
}

.text-white {
  color: var(--label);
}

.scrollbar-tema {
  scrollbar-width: thin;
  scrollbar-color: var(--scroll) transparent;
}
</style>
